import { makeAutoObservable } from 'mobx';

class LoadingStore {
  // 特定功能的加载状态
  loadingStates = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  // ==================== 特定功能加载状态管理 ====================

  startLoading(key, tip = '加载中...') {
    this.loadingStates.set(key, { loading: true, tip });
  }

  stopLoading(key) {
    this.loadingStates.delete(key);
  }

  getLoadingState(key) {
    return this.loadingStates.get(key) || { loading: false, tip: '' };
  }

  // 检查是否有任何loading状态
  get hasAnyLoading() {
    return this.loadingStates.size > 0;
  }

  // 重置所有loading状态
  reset() {
    this.loadingStates.clear();
  }
}

export const loadingStore = new LoadingStore();
